import React from 'react';
import { Listing, ListingContractType } from '@ha/api/v2/types/Listing';
import { useIntl } from 'ha/i18n';
import { Link } from '@hbf/dsl';
import { makeStyles } from 'tss-react/mui';
import { defineKey } from '@ha/intl';

const ADVERTISER_RENT_INFO_MESSAGES: Record<ListingContractType, string> = {
  [ListingContractType.DAILY]: defineKey(
    'advertiser_payment_info_button.daily_contract',
  ),
  [ListingContractType.FORTNIGHTLY]: defineKey(
    'advertiser_payment_info_button.fortnightly_contract',
  ),
  [ListingContractType.MONTHLY]: defineKey(
    'advertiser_payment_info_button.monthly_contract',
  ),
};
const TENANT_RENT_INFO_MESSAGES = {
  [ListingContractType.DAILY]: defineKey(
    'tenant_payment_info_button.daily_contract',
  ),
  [ListingContractType.FORTNIGHTLY]: defineKey(
    'tenant_payment_info_button.fortnightly_contract',
  ),
  [ListingContractType.MONTHLY]: defineKey(
    'tenant_payment_info_button.monthly_contract',
  ),
};
const useStyles = makeStyles()(theme => ({
  rentInfoBlock: {
    color: theme.palette.grey[600],
    marginBottom: theme.spacing(1),
  },
}));
export const RentInfo: React.FC<{
  contractType: Listing['contractType'];
  isAdvertiserVariant?: boolean;
}> = ({ contractType, isAdvertiserVariant }) => {
  const { T, urlResolver } = useIntl();
  const { classes } = useStyles();
  let linkText: string;
  let infoText: string;

  if (isAdvertiserVariant) {
    linkText = T('advertiser_payment_info_button.faq_link');
    infoText = T(ADVERTISER_RENT_INFO_MESSAGES[contractType]) || '';
  } else {
    linkText = T('tenant_payment_info_button.faq_link');
    infoText = T(TENANT_RENT_INFO_MESSAGES[contractType]) || '';
  }
  return (
    <div
      className={classes.rentInfoBlock}
      data-test-locator="PaymentDialog/RentInfoBlock"
    >
      {infoText}{' '}
      <Link
        to={urlResolver.getContractTypesArticleUrl()}
        target="_blank"
        kind="mint-underline"
      >
        {linkText}
      </Link>
    </div>
  );
};
